// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__EX0gP","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3sgyK","obliqueLine":"membershipbadge_obliqueLine__RNf42"};